import { Container } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import '../css/abooutus.css';
import Review from './review';

function Aboutus() {
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNo: '', // Added phone field
    email: '',
    serviceRating: '',
    suggestion: '',
  });
  const [isCooldown, setIsCooldown] = useState(false); // Cooldown state
  const [timer, setTimer] = useState(0); // Timer state

  



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  

    const payload = {
      
      FullName: formData.fullName,
      PhoneNo: formData.phoneNo,
      EmailAddress: formData.email,
      EmailSubject: "About Us - Suggestion",
       Message:
    `Name: ${formData.fullName}\n` +
    `Phone No: ${formData.phoneNo}\n` +
    `Email: ${formData.email}\n` +
    `Service Rating: ${formData.serviceRating}\n` +
    `Suggestion:\n${formData.suggestion}`
    };

    try {
       console.log("Payload object:", payload);
  console.log("Payload JSON string:", JSON.stringify(payload, null, 2));
      const response = await fetch('https://www.shorehamdrugs.com/web-api/pharmacy/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        alert('Your suggestion has been sent successfully!');
        setFormData({
          fullName: '',
          phoneNo: '',
          email: '',
          serviceRating: '',
          suggestion: '',
        });
      
      } else {
        alert('Failed to send feedback. Please try again.');
      }
    } catch (error) {
      console.error('Error sending feedback:', error);
      alert('Failed to send feedback. Please try again.');
    }
  };

  const startCooldown = () => {
    setIsCooldown(true);
    setTimer(300);
  };

  useEffect(() => {
    let interval;
    if (isCooldown && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsCooldown(false);
    }
    return () => clearInterval(interval);
  }, [isCooldown, timer]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  

  return (
    <Container className="my-5">
      {/* Preloader */}
      <div className="loader js-preloader">
        <div className="absCenter">
          <div className="loaderPill">
            <div className="loaderPill-anim">
              <div className="loaderPill-anim-bounce">
                <div className="loaderPill-anim-flop">
                  <div className="loaderPill-pill"></div>
                </div>
              </div>
            </div>
            <div className="loaderPill-floor">
              <div className="loaderPill-floor-shadow"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Banner Section */}
        <div className="aboutus-banner">
          <img
            src={'/img_2.jpeg'}
            alt="About Us Banner"
            className="aboutus-banner-img"
          />
          <div className="aboutus-banner-overlay"></div>
          <div className="aboutus-banner-content">
            <h1>About Us</h1>
          </div>
        </div>

        <div className="aboutus-service-section">
          <div className="aboutus-service-row">
            <div className="aboutus-service-image-stack">
              <img
          src={'/img_2.jpeg'}
          alt="Delivery"
          className="aboutus-service-img main-img"
              />
              <img
          src={'/img_3.jpeg'}
          alt="Medical Insurance"
          className="aboutus-service-img overlay-img"
              />
              <div className="aboutus-service-card">
          <img src="/favicon.ico" alt="Pharmacist" className="aboutus-service-card-logo" />
          <div>
            <div className="aboutus-service-card-title"></div>
            <div className="aboutus-service-card-subtitle">Quality Pharmacy</div>
          </div>
          <button className="aboutus-service-card-btn">
            <a className='yes' href="tel:+1631732-7373" style={{ textDecoration: 'none', }}>Call</a>
          </button>
              </div>
            </div>
            <div className="aboutus-service-content">
              <span className="aboutus-service-label">About</span>
              <h2 className="aboutus-service-title">Full Service Specialty Pharmacy</h2>
              <p className="aboutus-service-description" style={{ textAlign: 'justify' }}>
          At Quality Pharmacy, we take pride in being your neighborhood pharmacy that delivers top-quality service. Our goal is to provide exceptional care along with a wide range of products and services designed to promote your health and well-being. Since opening in 2016, we’ve combined the convenience of one-stop shopping with trusted, up-to-date solutions to meet your family’s pharmaceutical needs. Our knowledgeable pharmacists and friendly team are always ready to answer your questions and offer support on important matters such as medication costs, home care, insurance, and benefits. We prioritize giving every customer confidence and peace of mind when choosing us. To uphold our promise of excellence, we rely on advanced equipment and software systems to ensure dependable, accurate, and efficient service just what you should expect from a pharmacy you can trust.
              </p>
            </div>
          </div>
        </div>

        <div className="aboutus-stats-section">
          {/** 
          <div className="aboutus-stats-row">
            <div className="aboutus-stat">
              <div className="aboutus-stat-icon">
          <svg width="48" height="48" fill="#fff" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-7 .5c0-.83.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V4h-3v-.5zM19 21H5V5h2v2h10V5h2v16z"/></svg>
              </div>
              <div className="aboutus-stat-value">26,000 +</div>
              <div className="aboutus-stat-label">Free Home Delivered</div>
            </div>
            <div className="aboutus-stat">
              <div className="aboutus-stat-icon"></div>
              <div className="aboutus-stat-value">99.8 %</div>
              <div className="aboutus-stat-label">Customers Satisfied</div>
            </div>
            <div className="aboutus-stat">
              <div className="aboutus-stat-icon">
          {/* Bed SVG *
          <svg width="48" height="48" fill="#fff" viewBox="0 0 24 24"><path d="M21 10V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3H1v2h2v7h2v-7h12v7h2v-7h2v-2h-2zm-2 0H5V7h14v3z"/></svg>
              </div>
              <div className="aboutus-stat-value">4,800 +</div>
              <div className="aboutus-stat-label">Drugs Available</div>
            </div>
          </div>
          *
        </div>
        {/** */}
        <div className="aboutus-mission-vision-row">
          <div className="aboutus-mission-vision-card">
            <div className="aboutus-mission-vision-icon mission">

              {/* Shield SVG */}
              <svg width="40" height="40" fill="#003366" viewBox="0 0 24 24"><path d="M12 2l7 4v6c0 5.25-3.75 9.74-7 10-3.25-.26-7-4.75-7-10V6l7-4zm0 2.18L6 6.09v5.91c0 4.5 2.94 8.19 6 8.45 3.06-.26 6-3.95 6-8.45V6.09l-6-1.91zm-1 10.32l-2.12-2.12 1.41-1.41L11 12.59l3.71-3.71 1.41 1.41L11 14.5z"/></svg>
            </div>

            <div>
              <h3 className="aboutus-mission-vision-title">Mission</h3>
              <p className="aboutus-mission-vision-text" style={{ textAlign: 'justify' }}>
                At Quality Pharmacy, we are committed to helping our customers achieve and sustain their health, wellness, and overall well-being. Our role extends beyond providing medicines we also offer guidance, support, and the right medical care when needed. We aim to empower individuals with the knowledge and resources they need to take charge of their health and make confident, informed choices about their care.
              </p>
            </div>
          </div>
          <div className="aboutus-mission-vision-card">
            <div className="aboutus-mission-vision-icon vision">
              {/* Heart SVG */}
              <svg width="40" height="40" fill="#003366" viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>
            </div>
            <div>
              <h3 className="aboutus-mission-vision-title">Vision</h3>
              <p className="aboutus-mission-vision-text" style={{ textAlign: 'justify' }}>
               Our vision is to establish ourselves as a trusted leader in the pharmaceutical field by building a team of highly skilled professionals. We work toward this by encouraging effective treatment practices that allow us to deliver exceptional, patient-focused care. We aspire to be known for our strong community commitment and unwavering pursuit of excellence across every area of our operations, positioning us as a preferred choice for both patients and employees.
              </p>
            </div>
          </div>
        </div>
      </div>
  
      {/* Feedback Section */}
      <div className="aboutus-feedback-section">
        <div className="aboutus-feedback-container">
          <div className="aboutus-feedback-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="fullName">Full name</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  placeholder="Full name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  disabled={isCooldown} // Disable input during cooldown
                />
              </div>
              <div className="form-group">
                <label htmlFor="phoneNo">Phone Number</label>
                <input
                  type="text"
                  id="phoneNo"
                  name="phoneNo"
                  placeholder="Phone Number"
                  value={formData.phoneNo}
                  onChange={handleChange}
                  required
                  disabled={isCooldown} // Disable input during cooldown
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={isCooldown} // Disable input during cooldown
                />
              </div>
              <div className="form-group">
                <label htmlFor="serviceRating">Rate our Service</label>
                <select
                  id="serviceRating"
                  name="serviceRating"
                  value={formData.serviceRating}
                  onChange={handleChange}
                  required
                  disabled={isCooldown} // Disable input during cooldown
                >
                  <option value="">Select</option>
                  <option value="excellent">Excellent</option>
                  <option value="good">Good</option>
                  <option value="average">Average</option>
                  <option value="poor">Poor</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="suggestion">Suggestion</label>
                <textarea
                  id="suggestion"
                  name="suggestion"
                  placeholder="e.g. suggestion"
                  rows="4"
                  value={formData.suggestion}
                  onChange={handleChange}
                  disabled={isCooldown} // Disable input during cooldown
                ></textarea>
              </div>
              <button
                type="submit"
                className="feedback-submit-btn"
                disabled={isCooldown} // Disable button during cooldown
              >
                Send Now
              </button>
              {isCooldown && (
                <p className="cooldown-timer">
                  You can send feedback again in {formatTime(timer)}.
                </p>
              )}
            </form>
          </div>
          <div className="aboutus-feedback-info">
            <h2>Feedback for <br />Quality Pharmacy</h2>
            <p style={{ textAlign: 'justify' }}>
              Select Quality Pharmacy for caring service, professional advice, and quick, dependable support. Your health is our top priority, and we ensure it through personalized care, smooth insurance handling, and the convenience of free home delivery.
            </p>
            <h3>Customers Appreciate</h3>
            <p style={{ textAlign: 'justify' }}>
             At Quality Pharmacy, our customers appreciate the individualized attention, warm service, and professional guidance we provide at 249 Middle Country Rd, Selden, NY 11784.
            </p>
            <h3>Our Commitment</h3>
            <p style={{ textAlign: 'justify' }}>
              Your reliable health partner, offering tailored care and top-quality services at 249 Middle Country Rd, Selden, NY 11784.
            </p>
          </div>
        </div>
      </div>
      <Review />
    </Container>
  );
}

export default Aboutus;